// Category Reducer - manages active category state for the platform
// Default to 'boat' for backwards compatibility

const SET_ACTIVE_CATEGORY = 'SET_ACTIVE_CATEGORY';

const initialState = {
    activeCategory: 'boat' // 'boat' | 'posada' | 'experience'
};

export default function categoryReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ACTIVE_CATEGORY:
            if (['boat', 'posada', 'experience'].includes(action.payload)) {
                return { ...state, activeCategory: action.payload };
            }
            return state;
        default:
            return state;
    }
}

// Action creator
export function setActiveCategory(category) {
    return {
        type: SET_ACTIVE_CATEGORY,
        payload: category
    };
}

// Selector
export const getActiveCategory = (state) => state.category?.activeCategory || 'boat';
